import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  email: string;
  uid: string;
  photoURL: string;
  displayName: string;
}

const initialState: UserState = {
  email: '',
  uid: '',
  photoURL: '',
  displayName: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<UserState>) => {
      return { ...state, ...action.payload };
    },
    logout: (state) => {
      return { ...initialState };
    },
  },
});

export const { login, logout } = userSlice.actions;

export default userSlice.reducer;
